import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonCollapseItem from '../../../common-components/common-collapse-item';

const firstItemList = [
    {
        title: 'Как проходил процесс создания коммуникаций',
        subtitle: `<div class="letovo-complex-spoiler__text">Самым сложным в&nbsp;работе над проектом было наладить систему коммуникаций удаленными командами по&nbsp;интеграции сервисов. Главному менеджеру проекта Василию пришлось выступать в&nbsp;роли связующего звена Вебпрактик не&nbsp;только с&nbsp;клиентом, но&nbsp;еще и&nbsp;с&nbsp;разными командами интеграций. Команды предоставляли нам API, и&nbsp;мы&nbsp;обсуждали, как на&nbsp;программном уровне будем взаимодействовать и&nbsp;передавать друг другу данные. Но&nbsp;случалось и&nbsp;так, что на&nbsp;стороне интеграции сервиса менялась команда. Эти смены затруднили нашу работу, так как Васе приходилось устанавливать контакт с&nbsp;новым менеджером удаленной команды и&nbsp;распределять задачи между сторонами разработки. А&nbsp;все это отнимает время.
                    </div>
                    <br />
                    <div class="letovo-complex__text">За&nbsp;все время сотрудничества со&nbsp;Школой сменилось несколько команд по&nbsp;разным направлениям интеграций:</div>
                    <ul class="common__ol-list letovo-complex-spoiler__ol">
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #0cc0dd'>1.</span>
                            <span class="common__ol-info">Команда по&nbsp;внедрению на&nbsp;сайт CRM-системы. Успела сменить двух менеджеров проектов и&nbsp;двух программистов.</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #0cc0dd'>2.</span>
                            <span class="common__ol-info">Команда, которая внедряла систему прокторинга и&nbsp;дистанционного образования на&nbsp;платформе do.letovo.ru. сменилась на&nbsp;команду letovo.online.</span>
                        </li>
                        <li  class="common__ol-item">
                            <span class="common__ol-number" style='color: #0cc0dd'>3.</span>
                            <span class="common__ol-info">Потом команда <a href="https://potok.io/" rel="noopener noreferrer nofollow" target="_blank">potok.io</a> сменилась на&nbsp;команду сервиса <a href="https://huntflow.ru/" rel="noopener noreferrer nofollow" target="_blank">huntflow.ru</a>.</span>
                        </li>                        
                    </ul>
                    `,
    },
];

const secondItemList = [
    {
        title: 'Как проходил процесс изменения ',
        subtitle:
            'Сначала мы&nbsp;настроили интеграцию с&nbsp;системой дополнительного онлайн-образования do.letovo.ru. Но&nbsp;через какое-то время клиент решил, что пользовательский путь до&nbsp;платформы с&nbsp;дополнительным образованием слишком сложен и&nbsp;неочевиден. Также люди могут пользоваться возможностями дополнительного образования не&nbsp;только после отправки заявки на&nbsp;обучение, но&nbsp;и&nbsp;для тренировок перед поступлением. Поэтому пришлось отказаться от&nbsp;платформы do.letovo.ru и&nbsp;заменить ее&nbsp;на&nbsp;letovo.online. В&nbsp;связи с&nbsp;этим переходом нам нужно было настроить передачу информации с&nbsp;letovo.ru на&nbsp;letovo.online. Для этого мы&nbsp;подготовили пакет синхронизации данных о&nbsp;пользователях между площадками. Причем, формат пакета с&nbsp;данными должен был соответствовать запросу в&nbsp;методе api synchronization/user.',
    },
];

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper smallPaddings={true} className="letovo-complex">
                <div className="letovo-complex__top">
                    <CommonTitle>Сложности</CommonTitle>

                    <CommonUsualText className="letovo-complex__title">
                        Перед нами стояли две большие сложности, которые необходимо было преодолеть
                    </CommonUsualText>
                </div>

                <div className="letovo-complex__container">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="letovo-complex__item"
                    >
                        <div className="letovo-complex__item-img">
                            <img
                                src="/images/svg/letovo/communication_img.svg"
                                alt="Коммуникации"
                                title="Коммуникации"
                                loading="lazy"
                            />
                        </div>
                        <div className="letovo-complex__item-info">
                            <CommonSmallTitle className="letovo-complex__item-title">
                                01. Организация системы коммуникаций с&nbsp;удаленными командами
                                по&nbsp;интеграции сервисов
                            </CommonSmallTitle>
                            {firstItemList.map(({ title, subtitle }, index) => (
                                <CommonCollapseItem
                                    isNumber={false}
                                    index={++index}
                                    triggerText={title}
                                    content={parse(subtitle)}
                                    classParent={'letovo-complex__collapse-item'}
                                    key={++index}
                                />
                            ))}
                        </div>
                    </ScrollAnimation>

                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="letovo-complex__item letovo-complex__item--reverse"
                    >
                        <div className="letovo-complex__item-img">
                            <img
                                src="/images/svg/letovo/integration_img.svg"
                                alt="Переработка интеграций"
                                title="Переработка интеграция"
                                loading="lazy"
                            />
                        </div>
                        <div className="letovo-complex__item-info">
                            <CommonSmallTitle className="letovo-complex__item-title">
                                02. Переработка уже существующих интеграций в&nbsp;проекте
                            </CommonSmallTitle>
                            {secondItemList.map(({ title, subtitle }, index) => (
                                <CommonCollapseItem
                                    isNumber={false}
                                    index={++index}
                                    triggerText={title}
                                    content={parse(subtitle)}
                                    classParent={'letovo-complex__collapse-item'}
                                    key={++index}
                                />
                            ))}
                        </div>
                    </ScrollAnimation>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
